import { createMemoryHistory, createRouter } from 'vue-router'


export default  createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
        component: () => import('./views/Home.vue')
    },
    {
      path: '/editRulesSet/:id',
      name: 'editRulesSet',
      component: () => import('./views/EditRulesSet.vue')
    },
    {
        path: '/addRulesSet/',
        name: 'addRulesSet',
        component: () => import('./views/EditRulesSet.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});
